import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as common from '../../../../../common'
import * as models from '../../models'

import * as gql from './gql'

@ngCore.Injectable()
export class ApiService {
  /** TODO:  */
  public submitAction({
    pageContext,
    ref,
  }: models.action.Context): rxjs.Observable<ents.core.mosaic.Action.ExecutionResult> {
    ents.core.common.FlexibleIdentifier.validate(ref.action, {
      type: 'Mosaic Action identifier',
    })
    return gql.mutations.executeAction.execute({
      ...pageContext,
      actionIdentifier: ref.action,
      // FIXME: ScenarioId is required by GraphQL for action execution, but not
      // all applications support scenarios.
      // Consider refactoring executeAction to remove it from scenario mutation
      scenarioId: 'TODO',
      variableOverrides:
        common.gql.dms.data.inputs.variableValue.TRANSFORMER.getGqlFrom(
          ref?.variables,
        ),
    })
  }
}
